export default {
  deleteSubMessage: 'This action is irreversible.',
  deleteError:
    'There was a problem deleting your experiment. Distillery support has been contacted.  Please try again.',
};
